export default {
    modalShowImageVariations: {
        imageAi: 'Imagem AI',
        regenerateImage: 'Gerar novo conteúdo',
        description: 'Descrição',
        style: 'Estilo',
        saveToLibrary: 'Guardar na Biblioteca',
        continue: 'Continuar',
        cancel: 'Cancelar',
        select: 'Selecionar',
        copy: 'Cópia',
        selectedImage: 'Imagem selecionada',
        saved: 'Salvo',
        variations: 'Variações',
    },
};
